import { AwardNotification } from "../components/award-notification";
import { IBaseNotification } from "../types";
import { BaseNotificationModel } from "./base-notification-model";

export class AwardNotificationModel extends BaseNotificationModel {

  private readonly CONTAINER_ELEMENT_ID = 'award-notifications-container';
  private readonly LIST_ELEMENT_ID = 'award-notifications-list';
  private readonly ITEM_ELEMENT_CLASS = 'award-notification-item';

  constructor(notification: IBaseNotification) {
    super(notification);
  }

  get _notificationsWrapper() {
    let listWrapper = document.getElementById(this.LIST_ELEMENT_ID);

    if (!listWrapper) {
      const container = document.createElement('div');
      container.id = this.CONTAINER_ELEMENT_ID;
      container.classList.add('container', this.CONTAINER_ELEMENT_ID);

      listWrapper = document.createElement('ul');
      listWrapper.id = this.LIST_ELEMENT_ID;
      listWrapper.classList.add(this.LIST_ELEMENT_ID);
      container.appendChild(listWrapper);

      document.body.appendChild(container);
    }

    return listWrapper;
  }

  private _createNotificationElement() {
    const notificationElement = new AwardNotification();
    notificationElement.title = this.title;
    notificationElement.subtitle = this.message;
    notificationElement.type = this.type;

    return notificationElement;
  }

  private _createNotificationListItem(notificationElement: AwardNotification) {
    const listItem = document.createElement('li');
    listItem.id = this.id;
    listItem.classList.add(this.ITEM_ELEMENT_CLASS);
    listItem.appendChild(notificationElement);

    return listItem;
  }
  
  async show() {
    const wrapper = this._notificationsWrapper;
    const notificationElement = this._createNotificationElement();
    const listItem = this._createNotificationListItem(notificationElement);

    let markedAsDelivered = false;
    notificationElement.addEventListener('complete', () => {
      if (!markedAsDelivered) {
        markedAsDelivered = true;
        this.markAsDelivered();
      }
      wrapper.removeChild(listItem);
      this.showFloatingButtons();
      this.dispatchCompleteEvent();
    });

    notificationElement.addEventListener('notification-click', () => {
      markedAsDelivered = true;
      this.markAsDelivered();
    });

    wrapper.appendChild(listItem);
    this.hideFloatingButtons();
  }

  hideFloatingButtons() {
    const assistantBot = document.querySelector('tm-assistant-bot[popupmode="true"]');
    if (assistantBot) {
      assistantBot.setAttribute('hidden', 'true');
    }
  }

  showFloatingButtons() {
    const assistantBot = document.querySelector('tm-assistant-bot[popupmode="true"]');
    if (assistantBot) {
      assistantBot.removeAttribute('hidden');
    }
  }
}
